import { PartAvailability, PartLookUpResult } from 'api/generated';
import { create } from 'zustand';

type AvailabilityStoreType = {
  mainIndex?: number;
  rowIndex?: number;
  availability?: PartAvailability[] | null;
};

type AvailabilityStoreState = {
  availabilityState?: AvailabilityStoreType;
  setAvailabilityState: (st?: AvailabilityStoreType) => void;
};

export const useAvailabilityStore = create<AvailabilityStoreState>((set, get) => ({
  setAvailabilityState: (st) => {
    set({ availabilityState: st });
  }
}));
